import { isInArray, Lookup } from '../typeUtils';

export const supportedLanguages = [
  'en',
  'es',
  'de',
  'fr',
  'it',
  'pt_PT',
  'tr',
  'zh_CN',
  'zh_TW',
  'ru',
  'ja',
  'ko',
  'ar',
  'ca',
  'hi',
  'pl',
  'pt_BR',
] as const;

export type Language = Lookup<typeof supportedLanguages>;

export const isLanguage = (x: string): x is Language => isInArray(x, supportedLanguages);

export type PositionalTextParams = (string | number)[];
export type NamedTextParams<T extends string> = Record<T, string | number>;
export type PositionalReactParams = (string | number | object)[];
export type NamedReactParams<T extends string> = Record<T, string | number | object>;
